import React from 'react';
import './index.css';

const Button = ({ gtmLabel, gtmType, onClick, className, children, disabled }) => {
  return (
    <button
      className={`uni-btn + ${className}`}
      onClick={() => onClick ? onClick() : () => null}
      data-uvrs-label={gtmLabel || ''}
      data-uvrs-type={gtmType || ''}
      disabled={disabled}
    >
      {children}
    </button>
  );
};

export default Button;
